import OperationsController from "../adapters/user.controller";

const listUsers = async () => {
    const response = await OperationsController.listUsers('/all-drivers-enabled');
    return response;
}

export default listUsers;